<template>
  <div class="c-address c-address--add">
    <button
      v-show="!active"
      class="c-btn c-btn--primary c-btn--thin"
      :class="{ 'u-margin-auto': !addressesSaved }"
      @click="showForm"
    >
      + Add New Address
    </button>
    <div
      v-show="active"
      class="c-address-form"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import Address from '../../mixins/address';
export default {
  name: 'AccountNewAddress',
  mixins: [
    Address
  ],
  props: {
    addressesSaved: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    // eslint-disable-next-line no-undef
    if (!Shopify || !Shopify.CountryProvinceSelector) {
      console.error('Shopify Customer Area script not found.');
      return;
    }
    // eslint-disable-next-line no-undef, no-unused-vars
    const provinceSelector = new Shopify.CountryProvinceSelector(
      'AddressCountryNew',
      'AddressProvinceNew',
      { hideElement: 'AddressProvinceWrapperNew' },
    );
  },
};
</script>

<style lang="scss">
// unscoped for use in AccountSavedAddress.vue
.c-address {
  &__edit,
  &__delete {
    appearance: none;
    border: 0;
    background: none;
  }
}

.c-address-form {
  &__row {
    display: flex;
    flex-direction: column;
  
    @include respond-min('desktop') {
      flex-direction: row;
    }
  
    > * {
      flex: 1;
  
      @include respond-min('desktop') {
        &:not(:first-child) {
          margin-left: rem(14px);
        }
  
        &:not(:last-child) {
          margin-right: rem(14px);
        }
  
        &:only-child {
          margin-right: 0;
        }
      }
    }
  }

  &__select {
    padding: $select-padding;
    width: 100%;    
  }

  // output via liquid tags
  &__default input[type='checkbox'] {
    width: auto;
    margin-left: 1ch;
  }

  &__set-default {
    margin-right: 1ch;
  }
}
</style>